import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { useLocation } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';
import {
  flattenHTMLToAppURL,
  hasBlocksData,
  getBlocksFieldname,
  getBlocksLayoutFieldname,
  getBaseUrl,
} from '@plone/volto/helpers';
import config from '@plone/volto/registry';

const messages = defineMessages({
  unknownBlock: {
    id: 'unknownBlock',
    defaultMessage: 'Blocco sconosciuto',
  },
});
/**
 * TextOrBlocks view component class.
 * @function TextOrBlocks
 * @params {object} content: Content object.
 * @returns {string} Markup of the component.
 */
export const TextOrBlocks = ({
  content,
  exclude = ['title', 'description'],
}) => {
  /* Render text or blocks in view, skip title and description blocks by default*/
  const blocksFieldname = getBlocksFieldname(content);
  const blocksLayoutFieldname = getBlocksLayoutFieldname(content);
  const intl = useIntl();
  const location = useLocation();
  return (
    <>
      {hasBlocksData(content)
        ? map(content[blocksLayoutFieldname].items, (block) => {
            const blockType = content[blocksFieldname]?.[block]?.['@type'];

            if (exclude.indexOf(blockType) > -1) return null;

            const Block =
              config.blocks.blocksConfig[blockType]?.['view'] || null;
            if (Block != null) {
              return (
                <Block
                  key={block}
                  id={block}
                  properties={content}
                  data={content[blocksFieldname][block]}
                  path={getBaseUrl(location?.pathname || '')}
                />
              );
            } else {
              return (
                <div key={block}>
                  {intl.formatMessage(messages.unknownBlock, {
                    block: content[blocksFieldname]?.[block]?.['@type'],
                  })}
                </div>
              );
            }
          })
        : content.trama?.data && (
            <div
              dangerouslySetInnerHTML={{
                __html: flattenHTMLToAppURL(content.text.data),
              }}
            />
          )}
    </>
  );
};

TextOrBlocks.propTypes = {
  content: PropTypes.any,
};
